import { useState } from "react";
import "./applyModal.css";

export default function ApplyModal({ isOpen, onClose, jobTitle }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    resume: null,
  });

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  if (!isOpen) return null;

  // Handle input change
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // Basic validation
  const validateForm = () => {
    if (!formData.name.trim()) return "Full Name is required";
    if (!formData.email.includes("@")) return "Enter valid email address";
    if (formData.phone.length < 10) return "Enter valid phone number";
    if (!formData.resume) return "Please upload your resume";
    return null;
  };

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setSuccessMsg("");

    const validationError = validateForm();
    if (validationError) {
      setErrorMsg(validationError);
      return;
    }

    setLoading(true);

    try {
      const data = new FormData();
      data.append("jobTitle", jobTitle);
      data.append("name", formData.name);
      data.append("email", formData.email);
      data.append("phone", formData.phone);
      data.append("resume", formData.resume);

      const response = await fetch(
        "https://meetra-green-energy-backend.onrender.com/api/applications/apply",
        {
          method: "POST",
          body: data,
        }
      );

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(result.message || "Submission failed");
      }

      setSuccessMsg("🎉 Application submitted successfully!");
      setFormData({ name: "", email: "", phone: "", resume: null });

      setTimeout(() => {
        onClose();
      }, 2000);

    } catch (err) {
      setErrorMsg(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="apply-overlay" onClick={onClose}>
      <div className="apply-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>×</button>

        <h2>Apply for <span>{jobTitle}</span></h2>

        {errorMsg && <div className="error-msg">{errorMsg}</div>}
        {successMsg && <div className="success-msg">{successMsg}</div>}

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="text"
              name="name"
              placeholder=" "
              value={formData.name}
              onChange={handleChange}
              required
            />
            <label>Full Name</label>
          </div>

          <div className="input-group">
            <input
              type="email"
              name="email"
              placeholder=" "
              value={formData.email}
              onChange={handleChange}
              required
            />
            <label>Email Address</label>
          </div>

          <div className="input-group">
            <input
              type="tel"
              name="phone"
              placeholder=" "
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <label>Phone Number</label>
          </div>

          <div className="file-upload">
            <label className="file-label">
              {formData.resume ? formData.resume.name : "Upload Resume (.pdf, .doc, .docx)"}
              <input
                type="file"
                name="resume"
                accept=".pdf,.doc,.docx"
                onChange={handleChange}
                hidden
              />
            </label>
          </div>

          <button type="submit" disabled={loading}>
            {loading ? <span className="loader"></span> : "Submit Application"}
          </button>
        </form>
      </div>
    </div>
  );
}